// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  title: "Le titre est obligatoire",
  resume: "Le résumée est obligatoire",
  course: "Le cours est obligatoire",
  status: "Le status est obligatoire",
  price: "Le prix est obligatoire",
};
